<template>
	<div class="mid_scroll_content">
		<section class="depoist_fund  pb-5 border-0">
			<div class="row justify-content-center">
				<div class="col-12">
					<div class="getStart-screen">
						<div class="accordion  md-accordion accordion-11 beforeTriangle" id="accordionEx9" role="tablist" aria-multiselectable="true">
							<div class="accordion-header">
								<div class="accordion-content" role="tab" id="heading9">
									<a data-toggle="collapse" data-parent="#accordionEx9" href="#collapse9" aria-expanded="true" aria-controls="collapse9">
										<h5 class="font-thin">
											Personal Details <i data-feather="chevron-down"></i>
										</h5>
									</a>
								</div>
								<div id="collapse9" class="collapse show" role="tabpanel" aria-labelledby="heading9" data-parent="#accordionEx9">
									<div class="accordion-body mb-1 ">
										<p>Please ensure that your personal details are correct. You will be required to upload documents that verify these details.</p>
										<div class="submitButton mt-3">
											<router-link :to="'/individual-step'+(parseInt(get_user.step)+1)" class="cap_btn lowecase blue px-3 large_btn" v-if="parseInt(get_user.lead_type) == 0">Complete registration</router-link>
											<router-link :to="'/corporate-step'+(parseInt(get_user.step)+1)" class="cap_btn lowecase blue px-3 large_btn" v-if="parseInt(get_user.lead_type) == 1">Complete registration</router-link>
										</div>
									</div>
								</div>
							</div>
							<div class="accordion-header">
								<div class="accordion-content" role="tab" id="heading10">
									<a class="collapsed" data-toggle="collapseNone" data-parent="#accordionEx9" href="#collapse10" aria-expanded="false" aria-controls="collapse10">
										<h5 class="font-thin">
											Declarations <i data-feather="chevron-down"></i>
										</h5>
									</a>
								</div>
								<div id="collapse10" class="collapse" role="tabpanel" aria-labelledby="heading10" data-parent="#accordionEx9">
									<div class="accordion-body mb-1 ">
										<p>Agree to the terms of use and privacy policy</p>
										<div class="submitButton mt-3">
											<input type="submit" class="cap_btn lowecase blue px-3 large_btn" value="Complete Registration" name="" required="">
										</div>
									</div>
								</div>
							</div>
							<div class="accordion-header">
								<div class="accordion-content" role="tab" id="heading11">
									<a data-toggle="collapseNone" data-parent="#accordionEx9" href="#collapse11" aria-expanded="false" aria-controls="collapse11">
										<h5 class="font-thin">
											Upload Documents <i data-feather="chevron-down"></i>
										</h5>
									</a>
								</div>
								<div id="collapse11" class="collapse" role="tabpanel" aria-labelledby="heading11" data-parent="#accordionEx9">
									<div class="accordion-body mb-1 ">
										<p>Upload a proof of identity and a proof of address to complete verification</p>
										<div class="submitButton mt-3">
											<input type="submit" class="cap_btn lowecase blue px-3 large_btn" value="Complete Registration" name="" required="">
										</div>
									</div>
								</div>
							</div>
							<div class="accordion-header">
								<div class="accordion-content" role="tab" id="heading12">
									<a class="collapsed" data-toggle="collapseNone" data-parent="#accordionEx9" href="#collapse12" aria-expanded="false" aria-controls="collapse12">
										<h5 class="font-thin">
											Photo Verification <i data-feather="chevron-down"></i>
										</h5>
									</a>
								</div>
								<div id="collapse12" class="collapse" role="tabpanel" aria-labelledby="heading12" data-parent="#accordionEx9">
									<div class="accordion-body mb-1">
										<p>All users are required to upload a Verification photo.</p>
										<div class="submitButton mt-3">
											<input type="submit" class="cap_btn lowecase blue px-3 large_btn" value="Complete Registration" name="" required="">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
    name: 'after-login',
    data() {
        return {}
    },
	created(){
	
		this.pageName('Registration')
	}
}
</script>



// WEBPACK FOOTER //
// src/components/website/user/after-login.vue